module.exports = __webpack_public_path__ + "img/map0.9dae8fdd.jpg";